import PropTypes from 'prop-types'
import styles from './howItWorks.module.scss'
import { PageSection } from 'layout/pageSection'
import { Container } from 'layout/container'
import { Text } from 'typography/text'
import { useModifiers } from 'app/hooks/useModifiers'

const HowItWorksSection = ({ shifted }) => {
  const mods = useModifiers(styles, 'howItWorks', { shifted })

  const stepCount = 3
  const renderSteps = () => {
    const stepDescription = [
      {
        title: 'Step 1',
        text:
          'To book a ticket, register interest, or have your query answered - simply' +
          ' Call or Submit a form to our free service, and a travel agent will begin work on your request.',
      },
      {
        title: 'Step 2',
        text:
          'Receive communication from one of our partner travel agents to discuss multiple flights' +
          ' and itinerary options. Begin planning your dream vacation with your dedicated agent for free.',
      },
      {
        title: 'Step 3',
        text:
          'Choose from the provided itinerary options, or ask your agent for more options. ' +
          'Review and confirm the final itinerary, pay securely online, and receive your e-ticket.',
      },
    ]

    const steps = []
    for (let i = 0; i < stepCount; i++) {
      steps.push(
        <li key={i} id={i} className={styles.howItWorks__step}>
          <h3 className={styles.howItWorks__stepHeader}>{stepDescription[i].title}</h3>
          <Text className={styles.howItWorks__stepDescription}>{stepDescription[i].text}</Text>
        </li>
      )
    }
    return steps
  }

  return (
    <PageSection>
      <Container className={`${styles.howItWorks} ${mods}`} noPadding="md">
        <div className={styles.howItWorks__contentBlock}>
          <div className={styles.howItWorks__steps}>
            <h2 className={`h2`}>How it Works?</h2>
            <ol className={styles.howItWorks__stepDescriptionBlock}>{renderSteps()}</ol>
          </div>
          <div className={`${styles.howItWorks__image}`}>
            <img src="/static/img/howItWorks/how-it-works-mob.jpg" alt="" />
          </div>
          <div className={`${styles.howItWorks__image} ${styles.howItWorks__image_desktop}`}>
            <img src="/static/img/howItWorks/how-it-works-desk.jpg" alt="" />
          </div>
        </div>
      </Container>
    </PageSection>
  )
}

HowItWorksSection.propTypes = {
  shifted: PropTypes.bool,
}

export { HowItWorksSection }
